export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);

  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    return link;
  } finally {
    URL.revokeObjectURL(url);
  }
}
